var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#627EEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1239_5021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6541 28.9993V35.9993L30.2241 23.8965L21.6541 28.9993Z",
    fill: "#C0CBF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6531 8L30.2232 22.2617L21.6531 27.3645L13.0176 22.2617",
    fill: "#C0CBF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6531 8V18.3364L13.0176 22.2617M13.0176 23.8972L21.6531 29V36",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6541 18.3359V27.364L30.2241 22.2612",
    fill: "#8197EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0176 22.2612L21.6531 18.3359V27.364",
    fill: "#C0CBF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1239_5021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/Eth.7d8d23ea839bac249a77bc77ff34c00e.svg";
export { ForwardRef as ReactComponent };